import React from 'react';
import { format } from 'date-fns';
import { PageHeader, PageTitle } from '@cjdev/visual-stack/lib/components/PageHeader';
import PageContent from '@cjdev/visual-stack/lib/components/PageContent';
import { connect } from 'react-redux';
import {
    TableTitle,
    Table,
    THead,
    TBody,
    Tr,
    Th,
    Td,
} from '@cjdev/visual-stack/lib/components/Table';
import { Panel, Body } from '@cjdev/visual-stack/lib/components/Panel';
import { deployments } from '../deployments';

const formatTime = iso8601 => {
    const when = new Date(Date.parse(iso8601));

    return format(when, "MM/DD/YYYY hh:mm:ss A");
};

const Deployment = ({ deployment }) => {
    const info = deployment.info;
    const deployedAt = formatTime(info.deployedAt);
    const sourceHead = "Gitlab: " + info.sourceHead.hash;
    return (
        <React.Fragment>
            <Tr>
                <Td>{info.sourceRepository}</Td>
                <Td>{deployedAt}</Td>
                <Td>{sourceHead}</Td>
            </Tr>
        </React.Fragment>
    );
};

const Deployments = ({ deployments }) => {
    return (
        <React.Fragment>
            {deployments.map(a => <Deployment key={JSON.stringify(a)} deployment={a} />)}
        </React.Fragment>
    );
};

const ConnectedDeployments = connect(
    state => ({
        deployments: deployments(state)
    })
)(Deployments);


const DeploymentsPage = () => {
    return (
        <React.Fragment>
            <PageHeader>
                <PageTitle>Deployments</PageTitle>
            </PageHeader>
            <PageContent>
                <Panel>
                    <Body>
                            <TableTitle>Deployments</TableTitle>
                            <Table>
                                <THead>
                                    <Tr>
                                        <Th>Project</Th>
                                        <Th>Deployed Time</Th>
                                        <Th>Head Commit</Th>
                                    </Tr>
                                </THead>
                                <TBody>
                                    <ConnectedDeployments />
                                </TBody>
                            </Table>
                    </Body>
                </Panel>
            </PageContent>
        </React.Fragment>
    );
};


export { DeploymentsPage };



// WEBPACK FOOTER //
// ./src/view/DeploymentsPage.js